/**
 * Employee Documents — Constants
 */

export const LS_KEY_DOCUMENTS = "mcm_employee_documents";

export const DOCUMENT_CATEGORIES = [
  "Certification",
  "Contract",
  "Evaluation",
  "Training",
  "License",
  "Other",
];
